export default function VideoPlayer({ url }) {
  const getMimeType = () => {
    const extension = url?.split(".").pop()?.toLowerCase();
    switch (extension) {
      case "mp4":
        return "video/mp4";
      case "webm":
        return "video/webm";
      case "mov":
        return "video/quicktime";
      case "ogg":
        return "video/ogg";
      default:
        return "video/mp4";
    }
  };

  // Placeholder for VideoPlayer component
  return (
    <video
      className="video"
      controls={true}
      controlsList="nodownload"
      preload="auto"
      style={{ maxHeight: "400px", width: "100%", objectFit: "contain" }}
      src={url}
    >
      <source src={url} type={getMimeType()} />
      Your browser does not support the video tag.
    </video>
  );
}